export const locale = {
  lang: 'nl',
  data: {
    'PORTAL': {
      'BTN_SCREE_SHO': 'Maak screenshot',
      'TOTALCOLA': 'Totaal werknemers',
      'TOTALFAL': 'Werknemers die nog niet hebben gereageerd',
      'TOTALCONT': 'Medewerkers die al hebben gereageerd',
      'TOTALPRO': 'Totale vooruitgang',
      'TOTALLOG': 'Medewerkers die hun onderzoek niet hebben afgerond',
      'REPORTE': 'Aanbevolen aantal antwoorden voor...',
      'RANKING': 'Minimumaantal reacties voor...',
      'TOOLT_REPORTE': 'Aanbevolen aantal antwoorden voor het verkrijgen van statistisch significante resultaten per demografische cut-off',
      'TOOLT_RANKING': 'Minimumaantal antwoorden voor certificering/classificatie van het bedrijf',

      'REPORTE_CER_CARCA':'Aanbevolen aantal antwoorden om...',
      'TOOLT_REPORTE_CER_CARCA':'Aanbevolen aantal antwoorden om statistisch gezien resultaten te leveren per demografische cut-off, rekening houdend met het feit dat elke optie 5 antwoorden zal krijgen',
      'RANKING_CER_CARCA':'Minimum aantal antwoorden om...',
      'TOOLT_RANKING_CER_CARCA':'Minimum aantal antwoorden voor certificering / classificatie van de organisatie',

      'REPORTE_MED_CARCA':'Aanbevolen aantal antwoorden om...',
      'TOOLT_REPORTE_MED_CARCA':'Aanbevolen aantal antwoorden om statistisch gezien resultaten te leveren per demografische cut-off, rekening houdend met het feit dat elke optie 5 antwoorden zal krijgen',
      'RANKING_MED_CARCA':'Minimum aantal antwoorden om...',
      'TOOLT_RANKING_MED_CARCA':'Minimum aantal antwoorden voor certificering / classificatie van de organisatie',

      'TOTALMIN': 'Werknemers minimaal vereist',
      'TOTALGONE': 'Mensen die besloten hebben niet te antwoorden',
      'SELECTFPLA': 'Filters',
      'TBARRAPROGRESO': 'Huidige vooruitgang',
      'ACCESODENEGADO': 'Verlopen toegangslink',
      'ACCESOMSJPRE_1': 'De sluitingsdatum van de enquête is bereikt, deze portaalsite zal nog ',
      'ACCESOMSJPRE_2': ' dagen actief zijn.',
      'BTNOK': 'OK',
      'DIARESTA': 'Resterende dag',
      'NO-INFO': 'Afwezigheid van informatie in de database van medewerkers',
      'COLAB': 'Werknemers',
      'PORTAL_V1': 'Telportaal V1',
      'PORTAL_V2': 'Telportaal V2',
      'DI-TRANSCU': 'Verstreken dagen',
      'ETI_GRAFI_ZONA_HO': 'De datum in de grafiek is ingesteld op de lokale tijd in: ',
      'ETI_FILT_V1&V2': 'De met ( * ) gemarkeerde groepen tonen geen informatie omdat ze niet het minimum aantal gebruikers hebben dat nodig is om de voortgang weer te geven',
      'WAR_RESU_ARE_MIN5': 'Het minimumaantal reacties om resultaten per gebied weer te geven is 5',
      'FILTROS':{
        '1': 'Land',
        '2': 'Locatie',
        '3': 'Gebiedsafdeling',
        '4': 'Academische graad',
        '5': 'Afdeling',
        '6': 'Geografisch niveau 1',
        '7': 'Geografisch niveau 2',
        '8': 'Geografisch niveau 3',
        '9': 'Geografisch niveau 4',
        '10': 'Geografisch niveau 5',
        '11': 'Geografisch niveau 6',
        '12': 'Geografisch niveau 7',
        '13': 'Geografisch niveau 8',
        '14': 'Geografisch niveau 9',
        '15': 'Geografisch niveau 10',
        '16': 'Structureel niveau 1',
        '17': 'Structureel niveau 2',
        '18': 'Structureel niveau 3',
        '19': 'Structureel niveau 4',
        '20': 'Structureel niveau 5',
        '21': 'Structureel niveau 6',
        '22': 'Structureel niveau 7',
        '23': 'Structureel niveau 8',
        '24': 'Structureel niveau 9',
        '25': 'Structureel niveau 10',
        '26': 'Business Area',
        '27': 'Structureel niveau 2',
      },
      'COLUMNAS_TABLA':{
        'NIVEL1': 'Niveau 1',
        'NIVEL2': 'Niveau 2',
        'DEMOGRAFICO': 'Demografisch',
        'SEGMENTO': 'Segment',
        'COLABORADORES_T': 'Totaal aantal medewerkers',
        'PENDIENTES_RESPONDER': 'Medewerkers die nog niet hebben gereageerd',
        'YA_RESPONDIERON': 'Medewerkers die al hebben gereageerd',
        'AVANCE': 'Preview',
        'FILTERS': 'Filters',
      },
      'EXCEL_V2':{
        'TITULO_AVANCE': 'Voortgang van de uitvoering van de enquête door: ',
        'SHEET': 'Verslag',
        'DESCARGA': 'Telportaal van',
        'MODAL_DESCARGA': 'Download correct',
      },
      'ETIQUETAS':{
        'ETIQUETAS': 'Items per pagina',
        'OF': 'van',
        'BOTON':'Resetfilters'
      },
      'FILTROS_V2':{
        'ninguno': 'Geen',
        'Company': 'Bedrijf',
        'country': 'Land',
        'location': 'Locatie',
        'area': 'Gebied',
        'antiquity': 'Oudheid',
        'generation': 'Generatie',
        'charge': 'Laden',
        'homologado': 'Homologado',
        'gender': 'Geslacht',
        'typeofwork': 'Soort werk',
        'workCondition': 'Werkomstandigheden',
        'academico': 'Academische graad',
        'contratacion': 'Type contract',
        'personal': 'Soort personeel',
        'geo_1': 'Geografisch niveau 1',
        'geo_uno': 'Geografisch niveau 1',
        'geo_2': 'Geografisch niveau 2',
        'geo_3': 'Geografisch niveau 3',
        'geo_4': 'Geografisch niveau 4',
        'geo_5': 'Geografisch niveau 5',
        'geo_6': 'Geografisch niveau 6',
        'geo_7': 'Geografisch niveau 7',
        'geo_8': 'Geografisch niveau 8',
        'geo_9': 'Geografisch niveau 9',
        'geo_10': 'Geografisch niveau 10',
        'structure_1': 'Structureel niveau 1',
        'structure_2': 'Structureel niveau 2',
        'structure_3': 'Structureel niveau 3',
        'structure_4': 'Structureel niveau 4',
        'structure_5': 'Structureel niveau 5',
        'structure_6': 'Structureel niveau 6',
        'structure_7': 'Structureel niveau 7',
        'structure_8': 'Structureel niveau 8',
        'structure_9': 'Structureel niveau 9',
        'structure_10': 'Structureel niveau 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Structureel niveau 1',
        'structure_DOS': 'Structureel niveau 2',
        'structure_TRES': 'Structureel niveau 3',
        'structure_CUATRO': 'Structureel niveau 4',
        'structure_CINCO': 'Structureel niveau 5',
        'structure_SEIS': 'Structureel niveau 6',
        'structure_SIETE': 'Structureel niveau 7',
        'structure_OCHO': 'Structureel niveau 8',
        'structure_NUEVE': 'Structureel niveau 9',
        'structure_DIEZ': 'Structureel niveau 10',
        'bUnit': 'Bedrijfsafdeling',
      },
      'FILTROS_V2_HK':{
        'ninguno': 'Geen',
        'Company': 'Bedrijf',
        'country': 'Land',
        'location': 'Locatie',
        'area': 'Afdeling',
        'antiquity': 'Oudheid',
        'generation': 'Generatie',
        'charge': 'Positie of functie in de onderneming',
        'homologado': 'Homologado',
        'gender': 'Geslacht',
        'typeofwork': 'Soort werk',
        'workCondition': 'Werkomstandigheden',
        'academico': 'Academische graad',
        'contratacion': 'Type contract',
        'personal': 'Soort personeel',
        'geo_1': 'Geografisch niveau 1',
        'geo_uno': 'Geografisch niveau 1',
        'geo_2': 'Geografisch niveau 2',
        'geo_3': 'Geografisch niveau 3',
        'geo_4': 'Geografisch niveau 4',
        'geo_5': 'Geografisch niveau 5',
        'geo_6': 'Geografisch niveau 6',
        'geo_7': 'Geografisch niveau 7',
        'geo_8': 'Geografisch niveau 8',
        'geo_9': 'Geografisch niveau 9',
        'geo_10': 'Geografisch niveau 10',
        'structure_1': 'Structureel niveau 1',
        'structure_2': 'Structureel niveau 2',
        'structure_3': 'Structureel niveau 3',
        'structure_4': 'Structureel niveau 4',
        'structure_5': 'Structureel niveau 5',
        'structure_6': 'Structureel niveau 6',
        'structure_7': 'Structureel niveau 7',
        'structure_8': 'Structureel niveau 8',
        'structure_9': 'Structureel niveau 9',
        'structure_10': 'Structureel niveau 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Structureel niveau 1',
        'structure_DOS': 'Structureel niveau 2',
        'structure_TRES': 'Structureel niveau 3',
        'structure_CUATRO': 'Structureel niveau 4',
        'structure_CINCO': 'Structureel niveau 5',
        'structure_SEIS': 'Structureel niveau 6',
        'structure_SIETE': 'Structureel niveau 7',
        'structure_OCHO': 'Structureel niveau 8',
        'structure_NUEVE': 'Structureel niveau 9',
        'structure_DIEZ': 'Structureel niveau 10',
        'bUnit': 'Bedrijfsafdeling',
      },
      'PRODUCTO':{
        'CERT': 'Certificeren',
        'MED': 'Maatregel',
        'NOM35': 'Standaard 035',
        'PULSE': 'Pulsecheck',
        'FOCUS': 'Focusgebied',
        'MEDIR_1': 'Meting verbeterd',
        'MEDIR_2': 'Meting + MST',
        'MEDIR_3': 'Meting per gebied',
        'MEDIR_4': 'Meting door leiders',
        'MEDIR_5': 'Meting op maat',
        'MEDIR_6': 'Meting om te certificeren',
        'NAME': 'Bedrijf: ',
        'PRODUCTO': 'Product: ',
        'PORTAL': 'Telportaal',
        'LEADER_GO':'Leader Go',
        'AMCO':'AMCO',
        'TRAB_DIGN':'Fatsoenlijk werk',
        'PRI_EMPLE':'Eerste baan',

      },
      'EXCEL':{
        'NOMBOTON': 'Exporteer uitmuntend',
        'NOMBOTONREDUCIDO': 'Export om uit te blinken verminderd',
        'NOMEMPRE': 'BEDRIJFSNAAM:',
        'NOMUSUARIO': 'GEBRUIKERSNAAM:',
        'NOMPROD': 'PRODUCTNAAM:',
        'FERTILITY': 'LANCERINGSDATUM:',
        'FECHDESCA': 'DOWNLOADDATUM:',
        'DRESTAN': 'RESTERENDE DAG:',
        'TOTALCOLA': 'TOTALE WERKNEMERS:',
        'TOTALCONT': 'MEDEWERKERS DIE AL HEBBEN GEREAGEERD:',
        'TOTAAL': 'MEDEWERKERS DIE NOG NIET HEBBEN GEREAGEERD:',
        'TOTALPRO': 'TOTALE VOORUITGANG:',
        'RAPPORT': 'RESPONSE RATE FOR DELIVERABLES (minimum 85%):',
        'RANGSCHIKKING': 'MONSTER VOOR CERTIFICERING EN RANGSCHIKKING:',
        'FILT': 'FILTER:',
        'NOMFILT':' FILTERNAAM:',
        'INFOGENE': 'Algemeen verslag',
        'FILTROSNAME':{
          'country': 'Land',
          'location': 'Locatie',
          'area': 'Gebied',
          'antiquity': 'Oudheid',
          'generation': 'Generatie',
          'charge': 'Laden',
          'homologado': 'Homologado',
          'gender': 'Geslacht',
          'typeofwork': 'Soort werk',
          'workCondition': 'Werkomstandigheden',
          'academico': 'Academische graad',
          'contratacion': 'Type contract',
          'personal': 'Soort personeel',
          'geo_1': 'Geografisch niveau 1',
          'geo_2': 'Geografisch niveau 2',
          'geo_3': 'Geografisch niveau 3',
          'geo_4': 'Geografisch niveau 4',
          'geo_5': 'Geografisch niveau 5',
          'structure_1': 'Structureel niveau 1',
          'structure_2': 'Structureel niveau 2',
          'structure_3': 'Structureel niveau 3',
          'structure_4': 'Structureel niveau 4',
          'structure_5': 'Structureel niveau 5',
          'structure_6': 'Structureel niveau 6',
          'structure_7': 'Structureel niveau 7',
          'structure_8': 'Structureel niveau 8',
          'structure_9': 'Structureel niveau 9',
          'structure_10': 'Structureel niveau 10',
        }
      },
      'TIPO-PERSONAL':{
        'TIPO': 'Persoonlijk type',
        '1': 'Syndicaat',
        '2': 'Vertrouwen',
        '3': 'Beide',
      }

    },
    'PORTAL35': {
      'TOTALCOLA': 'Totaal werknemers',
      'TOTALFAL': 'Werknemers die nog niet hebben gereageerd',
      'TOTALCONT': 'Medewerkers die al hebben gereageerd',
      'TOTALPRO': 'Monster',
      'SELECTFPLA': 'Werkplaats',
      'TBARRAPROGRESO': 'Totale vooruitgang',
      'TOTALLOG': 'Medewerkers die hun onderzoek niet hebben afgerond',
      'TOTALGONE': 'Mensen die besloten hebben niet te antwoorden',
      'FILTROS':{
        '1': 'Werkcentrum',
        '2': 'Land',
        '3': 'Locatie',
        '4': 'Gebied',
        '5': 'Academische graad',
        '6': 'Afdeling',
        '7': 'Geografisch niveau 1',
        '8': 'Geografisch niveau 2',
        '9': 'Geografisch niveau 3',
        '10': 'Geografisch niveau 4',
        '11': 'Structureel niveau 1',
        '12': 'Structureel niveau 2',
        '13': 'Structureel niveau 3',
        '14': 'Geografisch niveau 8',
        '15': 'Geografisch niveau 9',
        '16': 'Geografisch niveau 10',
        '17': 'Hiërarchisch niveau 1',
        '18': 'Hiërarchisch niveau 2',
        '19': 'Hiërarchisch niveau 3',
        '20': 'Hiërarchisch niveau 4',
        '21': 'Hiërarchisch niveau 5',
        '22': 'Hiërarchisch niveau 6',
        '23': 'Hiërarchisch niveau 7',
        '24': 'Hiërarchisch niveau 8',
        '25': 'Hiërarchisch niveau 9',
        '26': 'Hiërarchisch niveau 10',
      }

    },
    'BTN':{
      'USERS':'Medewerkers'
    }
  }

};
